import React from "react";
import MarkdownContainer from "./markdown-container";
import MarkdownButton from "./markdown-button";
import Isvg from "../../../../vendor/react-inlinesvg";

class MarkdownButtonsList extends React.Component {
  constructor(props) {
    super();
    this.state = {
      showAll: false
    };
    this._toggle = this._toggle.bind(this);
    this._bold = this._bold.bind(this);
    this._italicize = this._italicize.bind(this);
    this._strikeThrough = this._strikeThrough.bind(this);
    // this._mark = this._mark.bind(this);
    this._subscript = this._subscript.bind(this);
    this._superscript = this._superscript.bind(this);
    this._link = this._link.bind(this);
    this._image = this._image.bind(this);
    this._toggleEmojiList = this._toggleEmojiList.bind(this);
    // this._youtube = this._youtube.bind(this);
    this._list = this._list.bind(this);
  }

  componentDidMount() {
    this.start = this.props.selectionStart;
    this.end = this.props.selectionEnd;
    this.noteText = this.props.note;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.start = nextProps.selectionStart;
    this.end = nextProps.selectionEnd;
    this.noteText = nextProps.note;
  }

  _list() {
    let lines = this.noteText.split("\n");
    let lineNumber = this.noteText.slice(0, this.start).split("\n").length - 1;

    if (!lines[lineNumber].match(/^[*|+|-]\s/)) {
      lines[lineNumber] = "+ " + lines[lineNumber];
      this.noteText = lines.join("\n");
      this.start += 2;
      this.end += 2;
    } else if (lines[lineNumber].length === 0) {
      this.noteText = "+ ";
      this.start += 2;
      this.end += 2;
    }

    this.props.onChange(this.noteText, this.start, this.end);
  }

  _markdownText(symbol, text) {
    const { textArea } = this.props;
    this.start = textArea.selectionStart === 0 ? 0 : this.start;
    this.end = textArea.selectionEnd || this.end;

    let begginingOfNote = `${this.noteText.slice(0, this.start)}`;
    begginingOfNote = begginingOfNote ? begginingOfNote + " " : begginingOfNote;

    if (this.start === this.end) {
      this.noteText = `${begginingOfNote}${symbol} ${text} ${symbol} ${this.noteText.slice(
        this.start
      )}`;
      this.end += text.length;
    } else {
      const markedDownText = `${symbol}${this.noteText
        .slice(this.start, this.end)
        .trim()}${symbol}`;
      const endOfNote = `${this.noteText.slice(this.end)}`;
      this.noteText = `${begginingOfNote}${markedDownText} ${endOfNote}`;
    }

    this.props.onChange(
      this.noteText,
      this.start + symbol.length,
      this.end + symbol.length
    );
  }

  _markdownAttachment(url, text, exclamation = "") {
    let markdown = exclamation + "[" + text + "](" + url + ")";

    if (this.start === this.end) {
      this.noteText =
        this.noteText.slice(0, this.start) +
        markdown +
        this.noteText.slice(this.start);
    } else {
      this.noteText =
        this.noteText.slice(0, this.start) +
        exclamation +
        "[" +
        text +
        "](" +
        this.noteText.slice(this.start, this.end) +
        ")" +
        this.noteText.slice(this.end);
    }

    this.end = this.start + text.length;
    this.props.onChange(
      this.noteText,
      this.start + exclamation.length + 1,
      this.end + exclamation.length + 1
    );
  }

  // _youtube() {
  //   if (this.start === this.end) {
  //     this.noteText = this.noteText.slice(0, this.start) + "@[youtube](VIDEO_ID)" + this.noteText.slice(this.start);
  //     this.end += 8;
  //   } else {
  //     this.noteText = this.noteText.slice(0, this.start) + "@[youtube](" +  this.noteText.slice(this.start, this.end) + ")" + this.noteText.slice(this.end);
  //   }
  //
  //   this.props.onChange(this.noteText, this.start + 11, this.end + 11);
  // }

  _addEmoji(emoji, e) {
    e.stopPropagation();
    e.nativeEvent.stopPropagation();
    if (this.start === this.end) {
      this.noteText =
        this.noteText.slice(0, this.start) +
        emoji +
        this.noteText.slice(this.start);
    } else {
      this.noteText =
        this.noteText.slice(0, this.start) +
        emoji +
        this.noteText.slice(this.end);
    }
    this.start += emoji.length;
    this.props.onChange(this.noteText, this.start, this.start);
    this._toggleEmojiList(e);
  }

  _emojiList() {
    if (this.props.dropdownOpen) {
      return <ul id="emoji-list">{this._emojiItems()}</ul>;
    } else {
      return null;
    }
  }

  _emojiItems() {
    return [
      ":smile:",
      ":wink:",
      ":anguished:",
      ":angry:",
      ":thumbsup:",
      ":thumbsdown:"
    ].map((emoji, idx) => (
      <li key={"emoji-" + idx}>
        <button className="noButton" onClick={e => this._addEmoji(emoji, e)}>
          <MarkdownContainer markdown={emoji} />
        </button>
      </li>
    ));
  }

  _toggleEmojiList(e) {
    e.stopPropagation();
    this.props.toggleDropdown();
  }

  _bold() {
    this._markdownText("**", "Bold Text");
  }

  _italicize() {
    this._markdownText("_", "Italicized Text");
  }

  _strikeThrough() {
    this._markdownText("~~", "Strikethrough Text");
  }

  // _mark() {
  //   this._markdownText("==", "Marked Text");
  // }

  _subscript() {
    this._markdownText("~", "Sub");
  }

  _superscript() {
    this._markdownText("^", "Sup");
  }

  _link() {
    this._markdownAttachment("URL", "Link Text");
  }

  _image() {
    this._markdownAttachment("ImageURL", "Alt Text", "!");
  }

  _toggle() {
    this.setState({ showAll: !this.state.showAll }, () => {
      if (this.state.showAll) {
        $(".emoji-container").on("click", this.stopPropagation);
      } else {
        $(".emoji-container").off("click", this.stopPropagation);
      }
    });
  }

  render() {
    return (
      <div>
        <ul
          id="markdown-buttons-list"
          className={this.props.className}
          style={this.props.style}
        >
          <li>
            <MarkdownButton
              onClick={this._bold}
              img="bold"
              dataTooltip="Bold"
            />
          </li>
          <li>
            <MarkdownButton
              onClick={this._italicize}
              img="italic"
              dataTooltip="Italicize"
            />
          </li>
          <li>
            <MarkdownButton
              onClick={this._strikeThrough}
              img="strikethrough"
              dataTooltip="Strikethrough"
            />
          </li>
          {this.state.showAll && (
            <li>
              <MarkdownButton
                onClick={this._subscript}
                img="subscript"
                dataTooltip="Subscript"
              />
            </li>
          )}
          {this.state.showAll && (
            <li>
              <MarkdownButton
                onClick={this._superscript}
                img="superscript"
                dataTooltip="Superscript"
              />
            </li>
          )}
          {this.state.showAll && (
            <li>
              <MarkdownButton
                onClick={this._image}
                img="image"
                dataTooltip="Image"
              />
            </li>
          )}
          {this.state.showAll && (
            <li>
              <MarkdownButton
                onClick={this._link}
                img="mdlink"
                dataTooltip="Link"
              />
            </li>
          )}
          {this.state.showAll && (
            <li className="emoji-container">
              <MarkdownButton
                onClick={this._toggleEmojiList}
                ariaExpanded={this.props.dropdownOpen}
                img="emoji"
                dataTooltip="Emojis"
                open={this.props.dropdownOpen}
              />
              {this._emojiList()}
            </li>
          )}
          {this.state.showAll && (
            <li>
              <MarkdownButton
                onClick={this._list}
                img="list"
                dataTooltip="List"
              />
            </li>
          )}
          <li className="noMargin">
            <button
              aria-expanded={this.state.showAll}
              className={"triangle " + (this.state.showAll ? "open" : "closed")}
              onClick={this._toggle}
            >
              <span className="offScreen">
                {this.state.showAll
                  ? i18n.t("collections.show-less")
                  : i18n.t("collections.show-more")}
              </span>
            </button>
          </li>
        </ul>
        <span id="saving">
          {this.props.saving && !this.state.showAll
            ? `${i18n.t("base.saving")}...`
            : null}
        </span>
      </div>
    );
  }
}

export default MarkdownButtonsList;

MarkdownButtonsList.defaultProps = {
  onChange: function() {},
  note: "",
  selectionStart: 0,
  selectionEnd: 0,
  contextMenu: false,
  style: {}
};
